import { Link } from "react-router-dom";
import { NavBar } from "../../components";
import "./LegalPage.css";

const AGB = () => {
  return (
    <div className="legal-page">
      <NavBar isHomePage={false} />
      <main className="legal-content">
        <Link to="/" className="legal-back text-placeholder hover:text-primary">
          ← Back to home
        </Link>
        <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
        <p className="legal-lead">
          Vertragspartnerin ist die <strong>apptive GmbH</strong>,
          Zunzgerstrasse 44, 4450 Sissach, Schweiz (UID CHE-278.833.895)—im
          Folgenden &quot;wir&quot; oder &quot;apptive&quot; genannt.
        </p>

        <h2>1. Geltungsbereich</h2>
        <p>
          Diese AGB gelten für alle Lieferungen und Leistungen im Bereich IT,
          Softwareentwicklung, Beratung und damit zusammenhängende
          Dienstleistungen, die wir für unsere Kundinnen und Kunden erbringen,
          sofern keine abweichende schriftliche Vereinbarung getroffen wird.
          Entgegenstehende oder von diesen AGB abweichende Bedingungen des
          Kunden erkennen wir nicht an.
        </p>

        <h2>2. Vertragsgegenstand und Mitwirkung</h2>
        <p>
          Gegenstand des Vertrags sind die individuell vereinbarten
          Arbeitsergebnisse (z.&nbsp;B. Konzepte, Software,
          Schnittstellendokumentation). Der Kunde stellt sämtliche
          Informations-, Zugangs- und Prüfungs Unterlagen rechtzeitig zur
          Verfügung und benennt eine kontaktfähige Ansprechperson.
        </p>

        <h2>3. Angebote und Preise</h2>
        <p>
          Angebote sind freibleibend, sofern nicht ausdrücklich als bindend
          gekennzeichnet. Preise verstehen sich in Schweizer Franken zuzüglich
          geltender Mehrwertsteuer (sofern schuldig). Zusätzlicher Aufwand, der
          durch Änderungen des Kunden nach Vertragsschluss entsteht, wird nach
          Aufwand berechnet, sofern nichts Abweichendes vereinbart ist.
        </p>

        <h2>4. Zahlungsbedingungen</h2>
        <p>
          Rechnungen sind innerhalb der auf der Rechnung genannten Frist ohne
          Abzug zahlbar. Bei Zahlungsverzug sind wir berechtigt, Verzugszinsen
          sowie angemessenes Mahngebühren in Rechnung zu stellen und die Arbeit
          einzustellen, bis eine ausstehende Zahlung beglichen ist.
        </p>

        <h2>5. Mitwirkung des Kunden bei Software und Schnittstellen</h2>
        <ul>
          <li>
            Bereitstellung von Testumgebungen, Zugängen und fachlicher
            Freigabe in vereinbarten Zyklen
          </li>
          <li>
            Eskalation von Mängeln mit nachvollziehbarer Schilderung
            (Reproduktionsschritte)
          </li>
        </ul>

        <h2>6. Urheber- und Nutzungsrechte</h2>
        <p>
          Soweit schriftlich vereinbart, räumen wir dem Kunden die vertraglich
          definierten Nutzungsrechte an den Arbeitsergebnissen ein—vorbehältlich
          vollständiger Bezahlung. Open-Source- und Drittbibliotheken bleiben
          ihren jeweiligen Lizenzen unterstellt und werden entsprechend
          dokumentiert.
        </p>

        <h2>7. Gewährleistung und Mängelanzeige</h2>
        <p>
          Mängel sind uns innerhalb einer angemessenen Frist schriftlich
          anzuzeigen. Wir beheben dokumentierte Fehler nach Wahl durch
          Nachbesserung oder Ersatzlieferung. Ansprüche des Kunden sind
          im Übrigen nach massgebendem Recht beschränkt, soweit gesetzlich
          zulässig.
        </p>

        <h2>8. Haftung</h2>
        <p>
          Wir haften bei Vorsatz und grober Fahrlässigkeit unbeschränkt. Bei
          einfacher Fahrlässigkeit haften wir nur für Schäden aus der
          Verletzung wesentlicher Vertragspflichten, jedoch begrenzt auf den bei
          Vertragsschluss vorhersehbaren typischen Schaden—ausser im Falle von
          Personenschäden. Eine weitergehende Haftung ist ausgeschlossen, soweit
          gesetzlich zulässig.
        </p>

        <h2>9. Datenschutz</h2>
        <p>
          Personendaten werden ausschliesslich zur Vertragsabwicklung und unter
          Beachtung des anwendbaren Datenschutzrechts verarbeitet. Details
          können—sofern vorhanden—in einer gesonderten Datenschutzerklärung
          geregelt sein.
        </p>

        <h2>10. Schlussbestimmungen</h2>
        <p>
          Es gilt schweizerisches Recht unter Ausschluss der Kollisionsnormen,
          soweit zulässig. Für Streitigkeiten aus oder im Zusammenhang mit diesen
          AGB sind die ordentlichen Gerichte am Sitz von apptive GmbH in Sissach
          zuständig, soweit kein zwingendes Gerichtsstandrecht entgegensteht.
          Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit
          der übrigen Bestimmungen unberührt.
        </p>
      </main>
    </div>
  );
};

export default AGB;
